import React from 'react';

import { Table, TableBody } from '@mui/material';
import { SortableContainer } from 'react-sortable-hoc';

import Restriction from './Restriction';

import { getRandomId } from '../../../../../utils';

const SortableRestrictions = SortableContainer(
  ({
    data,
    jels,
    classes,
    settings,
    addInnerRstCb,
    removeInnerRst,
    setColumnTitle,
    onRemoveRstClick,
    openFrmEditModal,
    onRstNestedDragEnd,
    handleRendererChange,
    onShowPidsFieldChange,
    conceptRestrictionsIds,
    switchColumnToMultipleChains,
    addNewShowPidToMultipleChains,
    onCustomLayoutColumnItemChange,
    removePidInMultipleChains,
  }) => {
    return (
      <TableBody>
        {settings.show_pids.map((rstData, columnIndex) => {
          if (rstData.hasOwnProperty('custom_component') && !rstData.id) rstData.id = getRandomId();
          return (
            <Restriction
              data={data}
              jels={jels}
              rstData={rstData}
              classes={classes}
              index={columnIndex}
              settings={settings}
              columnIndex={columnIndex}
              addInnerRstCb={addInnerRstCb}
              removeInnerRst={removeInnerRst}
              setColumnTitle={setColumnTitle}
              onRemoveRstClick={onRemoveRstClick}
              openFrmEditModal={openFrmEditModal}
              onRstNestedDragEnd={onRstNestedDragEnd}
              handleRendererChange={handleRendererChange}
              key={(rstData && rstData.id) || columnIndex}
              onShowPidsFieldChange={onShowPidsFieldChange}
              conceptRestrictionsIds={conceptRestrictionsIds}
              switchColumnToMultipleChains={switchColumnToMultipleChains}
              addNewShowPidToMultipleChains={addNewShowPidToMultipleChains}
              onCustomLayoutColumnItemChange={onCustomLayoutColumnItemChange}
              removePidInMultipleChains={removePidInMultipleChains}
            />
          );
        })}
      </TableBody>
    );
  }
);

const TableRestrictions = ({
  data,
  jels,
  classes,
  settings,
  onRstDragEnd,
  addInnerRstCb,
  removeInnerRst,
  setColumnTitle,
  onRemoveRstClick,
  openFrmEditModal,
  onRstNestedDragEnd,
  handleRendererChange,
  onShowPidsFieldChange,
  conceptRestrictionsIds,
  removePidInMultipleChains,
  switchColumnToMultipleChains,
  addNewShowPidToMultipleChains,
  onCustomLayoutColumnItemChange,
}) => {
  const handleSortStart = ({ node }) => {
    const tds = document.getElementsByClassName(`${classes.draggableItemHelper}`)[0].childNodes;
    node.childNodes.forEach((node, idx) => (tds[idx].style.width = `${node.offsetWidth}px`));
  };

  return (
    <Table className={`${classes.mr10} ${classes.mb10}`}>
      <SortableRestrictions
        data={data}
        jels={jels}
        useDragHandle
        classes={classes}
        settings={settings}
        onSortStart={handleSortStart}
        addInnerRstCb={addInnerRstCb}
        removeInnerRst={removeInnerRst}
        setColumnTitle={setColumnTitle}
        onRemoveRstClick={onRemoveRstClick}
        openFrmEditModal={openFrmEditModal}
        onRstNestedDragEnd={onRstNestedDragEnd}
        handleRendererChange={handleRendererChange}
        removePidInMultipleChains={removePidInMultipleChains}
        switchColumnToMultipleChains={switchColumnToMultipleChains}
        addNewShowPidToMultipleChains={addNewShowPidToMultipleChains}
        onCustomLayoutColumnItemChange={onCustomLayoutColumnItemChange}
        onShowPidsFieldChange={onShowPidsFieldChange}
        onSortEnd={({ oldIndex, newIndex }) => {
          onRstDragEnd(oldIndex, newIndex);
        }}
        helperClass={`${classes.draggableItemHelper}`}
        conceptRestrictionsIds={conceptRestrictionsIds}
      />
    </Table>
  );
};

export default TableRestrictions;
